import React from "react";

export default function IconEquipment({ icon, alt }) {
    return (
        <img src={icon} alt={alt} className="max-w-[24px] max-h-[24px]" />
    );
}